import axios from 'axios'

export const fetchUserGuide = () =>
  axios.get('/authenticated/user-guide').then((response) => response.data)
